var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppetite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9997 5.33331C17.2721 5.33331 5.33301 17.2724 5.33301 32C5.33301 46.7274 17.2721 58.6666 31.9997 58.6666C46.7271 58.6666 58.6663 46.7274 58.6663 32C58.6663 17.2724 46.7271 5.33331 31.9997 5.33331ZM21.333 32C21.333 26.1089 26.1086 21.3333 31.9997 21.3333C33.4725 21.3333 34.6663 20.1394 34.6663 18.6666C34.6663 17.1939 33.4725 16 31.9997 16C23.1631 16 15.9997 23.1634 15.9997 32C15.9997 33.4728 17.1936 34.6666 18.6663 34.6666C20.1391 34.6666 21.333 33.4728 21.333 32ZM26.6663 32C26.6663 29.0544 29.0541 26.6666 31.9997 26.6666C32.4775 26.6666 32.9405 26.7296 33.381 26.8472L40.7807 19.4477C41.8221 18.4063 43.5106 18.4063 44.5519 19.4477C45.5933 20.4891 45.5933 22.1775 44.5519 23.2189L37.1525 30.6186C37.2701 31.0592 37.333 31.5221 37.333 32C37.333 34.9456 34.9453 37.3333 31.9997 37.3333C29.0541 37.3333 26.6663 34.9456 26.6663 32Z",
    fill: "#00AFB9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppetite);
export default __webpack_public_path__ + "static/media/appetite.1d15385e3405bb31ac84d534f8c75001.svg";
export { ForwardRef as ReactComponent };